export default {"src":"/_next/static/image/src/images/Footer/mail.9644c66d0f335be21cb427e3907aa609.svg","height":12,"width":20};